import GameInstructions from "../../components/GameInstructions/GameInstructions";
import Layout from "../../components/Layout/Layout";

const SwingGameInstructions = () => {
  return (
    <Layout requiresAuth={true}>
      <GameInstructions game="swing" />
    </Layout>
  );
};

export default SwingGameInstructions;
